import { CanActivateFn, Router } from '@angular/router';
import { PermissionsService, PermissionType, RoleType } from '../services/permissions.service';
import { inject } from '@angular/core';

export const accessRuleGuard: CanActivateFn = (route) => {
  const permissionService = inject(PermissionsService);
  const router = inject(Router);
  const roles = (route.data['roles'] as RoleType[] | undefined) ?? [];
  const permissions = (route.data['permissions'] as PermissionType[] | undefined) ?? [];

  if (roles.length > 0) {
    const hasRole = permissionService.hasAnyRole(roles);
    if (!hasRole) {
      return router.createUrlTree(['/not-allowed']);
    }
  }
  if (permissions.length > 0) {
    const hasPermission = permissionService.hasAnyPermission(permissions);
    if (!hasPermission) {
      return router.createUrlTree(['/not-allowed']);
    }
  }

  return true;
};
